import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Home, Heart, BookOpen, Search, Sparkles } from 'lucide-react';
const features = [{
  icon: Leaf,
  title: 'Remedios Naturales',
  description: 'Caseros para molestias comunes, defensas bajas, resfríos, digestión, piel y bienestar general.'
}, {
  icon: Home,
  title: 'Trucos de Hogar',
  description: 'Limpieza simple, económica y efectiva con ingredientes que ya tenés.'
}, {
  icon: Heart,
  title: 'Cuidado Personal',
  description: 'Consejos prácticos para el cuidado del cuerpo, el descanso y la rutina diaria.'
}, {
  icon: BookOpen,
  title: 'Paso a Paso',
  description: 'Todo explicado sin términos raros ni complicaciones innecesarias.'
}];
export function WhatsIncludedSection() {
  return <section className="py-24 bg-[#FFF8F0] px-4 sm:px-6 lg:px-8" data-id="element-177">
      <div className="max-w-6xl mx-auto" data-id="element-178">
        <div className="text-center mb-16" data-id="element-179">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#5C4033] mb-4" data-id="element-180">
            Qué incluye el manual
          </h2>
          <div className="w-24 h-1 bg-[#D4A5A5] mx-auto rounded-full" data-id="element-181" />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-182">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-[#E5D0C5]" data-id="element-183">
              <div className="w-12 h-12 bg-[#F4EBE8] rounded-full flex items-center justify-center mb-4 text-[#D4A5A5]" data-id="element-184">
                <feature.icon className="w-6 h-6" data-id="element-185" />
              </div>
              <h3 className="text-xl font-serif font-bold text-[#5C4033] mb-3" data-id="element-186">
                {feature.title}
              </h3>
              <p className="text-[#6B5A4D] text-sm leading-relaxed" data-id="element-187">
                {feature.description}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-20 bg-[#8B7355] rounded-2xl p-8 md:p-12 text-white relative overflow-hidden" data-id="element-188">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-189" />

          <div className="relative z-10 text-center max-w-3xl mx-auto" data-id="element-190">
            <h3 className="text-2xl md:text-3xl font-serif font-bold mb-8" data-id="element-191">
              Cómo funciona
            </h3>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-192">
              <div className="flex flex-col items-center" data-id="element-193">
                <div className="w-10 h-10 rounded-full bg-[#FFF8F0] text-[#8B7355] flex items-center justify-center font-bold text-lg mb-4" data-id="element-194">
                  1
                </div>
                <p data-id="element-195">Descargás el manual inmediatamente</p>
              </div>
              <div className="flex flex-col items-center" data-id="element-196">
                <div className="w-10 h-10 rounded-full bg-[#FFF8F0] text-[#8B7355] flex items-center justify-center font-bold text-lg mb-4" data-id="element-197">
                  2
                </div>
                <p data-id="element-198">Buscás el problema que querés resolver</p>
              </div>
              <div className="flex flex-col items-center" data-id="element-199">
                <div className="w-10 h-10 rounded-full bg-[#FFF8F0] text-[#8B7355] flex items-center justify-center font-bold text-lg mb-4" data-id="element-200">
                  3
                </div>
                <p data-id="element-201">Aplicás la solución con lo que tenés en casa</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}